import { useBetslipStore } from '@/store/betslip';
import { SingleBet } from './components/single-bet';
import { MultiBet } from './components/multi-bet';
import { QuickBet } from './components/quick-bet';
import { useAsideBetslip } from '../hook/use-aside-betslip';

export const BetslipContainer = () => {
	const betslipType = useBetslipStore(state => state.betslipType);
	const { activeAsideBetSlip } = useAsideBetslip();
	return (
		<>
			{
				{
					single: <SingleBet />,
					multi: <MultiBet />,
					quickbet: activeAsideBetSlip ? <QuickBet /> : null,
					empty: null,
				}[betslipType]
			}
		</>
	);
};